import { useEffect, useState } from 'react';
import arrow from '../../../../../../../assets/arrow.svg';
import { Divider } from 'antd';
import { DraggableItem } from './DraggableItem';

export const LinkedFieldsComponent = ({ linkedFields, iconsMap }: any) => {
    const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});

    useEffect(() => {
        if (linkedFields) {
            const initialCollapsed: Record<string, boolean> = linkedFields.reduce((acc: any, el: any) => {
                acc[el.id] = false;
                return acc;
            }, {} as Record<string, boolean>);

            setCollapsed(initialCollapsed);
        }
    }, [linkedFields]);

    const toggleCollapse = (id: string) => {
        setCollapsed((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    return (
        <>
            {linkedFields?.map((el: any) =>
                el.fields?.length ? (
                    <div key={el.id} className={`linked-block ${!collapsed[el.id] ? 'open' : ''}`}>
                        <div className="linked-block__header" style={{ display: 'flex', alignItems: 'center' }}>
                            <div>{el.name}</div>{' '}
                            <span style={{ cursor: 'pointer', marginRight: 8 }} onClick={() => toggleCollapse(el.id)}>
                                <img src={arrow} className={collapsed[el.id] ? 'open' : 'close'} alt="" />
                            </span>
                        </div>

                        {!collapsed[el.id] && (
                            <>
                                <Divider style={{ margin: '10px 0' }} />
                                <div className="linked-block__fields" style={{ marginLeft: 24 }}>
                                    {el.fields.map((field: any) => (
                                        <DraggableItem id={field.id} key={field.id} type={'linked'}>
                                            <>
                                                <div className="linked-block__field">
                                                    <div className="linked-block__field-header">
                                                        {iconsMap?.[field.type]?.('#808cb2')} {field.title}
                                                    </div>
                                                    <div className="linked-block__field-main">{field.label}</div>
                                                </div>
                                            </>
                                        </DraggableItem>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                ) : (
                    <></>
                )
            )}
        </>
    );
};
